import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { DocumentIntake, DocumentIntakeViewBasic } from "generated/graphql";
import useAppDispatchWithSnackbar from "helpers/hooks/useAppDispatchWithSnackbar";
import { useState } from "react";
import { deleteIntake } from "redux/slices/case";

interface DeleteIntakeProps {
  open: boolean;
  close: () => void;
  intakes: (DocumentIntake | DocumentIntakeViewBasic)[];
}

const BulkDeleteIntakeDialog = (props: DeleteIntakeProps) => {
  const { open, close, intakes } = props;
  const [deleting, setDeleting] = useState(false);
  const snackpatch = useAppDispatchWithSnackbar();
  const doBulkDeleteIntakes = async () => {
    setDeleting(true);
    // Await all promises complete, promises are snackpatches to delete intakes
    await Promise.all(
      intakes.map((intake) =>
        snackpatch(deleteIntake({ intakeId: intake.id }), {
          successMessage: "Document deleted",
          errorMessage: "Unable to delete document",
        })
      )
    )
      .then(() => {
        close();
      })
      .finally(() => {
        setDeleting(false);
      });
  };

  return (
    <Dialog open={open} onClose={close}>
      <DialogTitle>Bulk Delete Documents</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to permanently delete <b>{intakes.length}</b> documents?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="default" onClick={close}>
          Cancel
        </Button>
        <Button color="warning" variant="contained" disabled={deleting} onClick={doBulkDeleteIntakes}>
          {deleting ? "Deleting" : "Delete"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BulkDeleteIntakeDialog;
